import React from 'react';

function SpecialMessageScreen() {
  return (
    <div
      className="flex h-screen flex-col justify-between"
      style={{ backgroundColor: '#23339D' }}
    >
      {/* Header */}
      <header
        className="relative border-b-2 p-4"
        style={{ backgroundColor: '#fff', borderColor: '#000' }}
      >
        <div className="items-right flex justify-end">
          <img
            src="https://swqvc4jret.ufs.sh/f/aGnUnqmi8ZcvsNnth6gfVxRnUjehuSBqQJ6E2ymNLocgOA9a"
            alt="JPark Logo"
            className="max-h-[9.6vh] min-w-[30vw] object-contain"
          />
        </div>
        <div className="absolute left-[calc(-300px+-1.6vh)] top-[calc(-220px-5.6vh)] h-[calc(400px+12.6vh)] w-[calc(400px+9.6vh)] -translate-x-8 rotate-45 transform bg-secondary"></div>
      </header>

      {/* Main Content */}
      <div
        className="flex flex-grow flex-col justify-between px-[8vw] py-[2vh]"
        style={{ backgroundColor: '#23339D', color: '#fff' }}
      >
        {/* Title */}
        <div className="flex flex-col justify-center gap-1 grow pt-[30%]">
          <div className="flex flex-col items-center">
            <h2 className="mb-[-1vh] text-[10vw] font-bold">EVENT RATE</h2>
            <p className="text text-[6vw] font-bold leading-none" style={{ color: '#8FBA02' }}>
              Tarif événement
            </p>
          </div>

          <div>
            <div className=" flex justify-center ml-10 mt-[-3vh]">
              <h1 className="text-[17vh] font-bold mr-[6vw]">25</h1>
              <span className="ml-[-70px] text-[10vh] font-bold leading-[2] mr-[10px]">$</span>
            </div>
          </div>
        </div>

        {/* Price Highlight */}


          <div className="flex flex-col items-center justify-end pt-[15vh]">
            <p className={"text-[7vw] font-semibold leading-none"} >Happy Canada Day!</p>
            <p className={"text-[7vw] leading-[1.2]"} style={{ color: '#8FBA02' }}>Bonne fête du Canada!</p>
          </div>
        {/* Rates List */}
        {/*<div >
          {rates.map((rate, index) => (
            <div
              key={index}
              className="flex justify-between border-b-[8px] py-[1.7vh]"
              style={{ borderColor: '#F6D21D' }}
            >
              <div className="flex max-w-[69%] flex-col justify-center">
                <p className="text-[4vw] font-bold leading-[1.2]">
                  {rate.description}
                </p>
                {rate.descriptionFr && (
                  <p
                    className="text-[1.6vh] font-bold leading-[1.2]"
                    style={{ borderColor: '#8FBA02' }}
                  >
                    {rate.descriptionFr}
                  </p>
                )}
              </div>

              <p
                className="flex flex-col justify-center text-[5vw] font-extrabold"
                style={{ color: '#F6D21D' }}
              >
                {rate.price}
              </p>
            </div>
          ))}

          <p className="mt-[2vh] text-[1.2vh] font-bold">
            Rates based on 12 hours time limit, plus service fees if applicable.
            <br />
            Tarifs Basés pour une limite de 12 heures, plus frais de service, le
            cas échéant
          </p>
        </div>*/}
      </div>

      {/* Footer */}
      <footer className="py-6 text-center" style={{ color: '#fff', backgroundColor: '#8FBA02' }}>
        <p className="text-[2vh] font-extrabold" style={{ color: '#292520' }}>
          www.j-park.ca
        </p>
        <p className="text-[6vw] font-extrabold" style={{ color: '#292520' }}>
          (343) 204-1468
        </p>
      </footer>
    </div>
  );
}

export default SpecialMessageScreen;
